import type { MailboxInfo } from 'owa-client-types';
import { getApplicationSettings } from 'owa-application-settings';
import {
    isOfflinePeopleDataViaPDVEnabled,
    type PDVStateDetails,
} from './isOfflinePeopleDataViaPDVEnabled';

export function isPDVHeaderInfoAndCardTypeEnabled(
    viewerMailboxInfo: MailboxInfo,
    pdvStateDetails?: PDVStateDetails
): boolean {
    // We are intentionally not passing in MailboxInfo to below
    // flight checks because framework sync currently is
    // completely conditioned on the global settings mailbox account's
    // flights since they have some trouble at this time
    // to completely flight offline by account.
    const isOfflineTemplateEnabled = getApplicationSettings('PDV').peoOfflineTemplate;

    const innerPDVStateDetails = pdvStateDetails ?? {};
    isOfflinePeopleDataViaPDVEnabled(viewerMailboxInfo, innerPDVStateDetails);

    if (pdvStateDetails) {
        pdvStateDetails = { ...pdvStateDetails, ...innerPDVStateDetails };
        pdvStateDetails.isOfflineTemplateEnabled = isOfflineTemplateEnabled;
    }
    // Keeping the offline template enabled only when offline PDV is enabled where the data is available.
    // With online PDV, we need to depend on Loki for the data
    return (
        Boolean(innerPDVStateDetails.isOfflinePeopleDataViaPDVEnabledAllUp) &&
        isOfflineTemplateEnabled
    );
}
